export default __webpack_public_path__ + "static/media/fastfix01.43622f24.jpg";